import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    mobile: '',
    pass: '',
  })
  const [responseMsg, setResponseMsg] = useState('');
  const navigate = useNavigate();

  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setResponseMsg('');

    if (formData.mobile === '7503202735' && formData.pass === '7535') {
      // If they match, navigate to the dashboard
      localStorage.setItem('isLoggedIn', 'true');
      setResponseMsg('Login Successful');
      setTimeout(() => {
        setResponseMsg('');
        navigate('/dashboard');
        window.location.reload();
      }, 1000)
    } else {
      setResponseMsg('Invalid username or password');
      setTimeout(() => {
        setResponseMsg('');
      }, 2000)
    }
  }


  return (
    <>
      <section className='my-5 px-4 align-content-center'>
        <div className='container text-center col-lg-4 col-md-6 col-12 mx-auto py-5 rounded-2 my-5' style={{ boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.126)' }}>

          <p className='fs-4 fw-bold'>Admin Login</p>

          <form class="row g-3 mt-4" onSubmit={handleLogin}>
            {responseMsg && <p className='my-0 fw-semibold text-muted text-decoration-underline fst-italic'>{responseMsg}</p>}
            <div class="col-12">
              <input type="tel" class="w-100 rounded py-3 px-3 border-dark-subtle" id="inputMobile4" name='mobile' maxLength='10' onChange={handleChange} value={formData.mobile} placeholder='Mobile Number' />
            </div>
            <div class="col-12">
              <input type="password" class="w-100 rounded py-3 px-3 border-dark-subtle" id="inputPassword4" name='pass' onChange={handleChange} value={formData.pass} placeholder='Your Password' />
            </div>
            <div class="col-12 mt-4">
              <button type="submit" class="submit-btn w-100">Login Now</button>
            </div>
          </form>

        </div>
      </section>
    </>
  )
}

export default AdminLogin
